<awn-client-request-panel
  [instance]="entity()?.request"
  [isUsingSecureLink]="true"
  [canShowCompletionDialog]="canShowCompletionDialog()"
  (submissionCompleted)="onSubmissionCompleted$.next()"
></awn-client-request-panel>
